// extracted by mini-css-extract-plugin
module.exports = {"root":"IU7ZTKn6w9ljSHMMmAQ_"};